import { Row, Modal } from 'react-bootstrap';
import styled, { css } from 'styled-components';
import CustomButton from '../../../../app/components/button/CustomButton';
import SearchInput from '../../../landingPage/components/SearchInput';
import bgBasket from '../images/bg-basket.svg';
import bgFlower from '../images/bg-flower.svg';
import ShopIcon from '../images/shop.svg';
import StyledButton from '../../../../app/components/styledComponents/StyledButton';
import { CustomDropdownStyle } from '../../../../app/components/styledComponents/StyledCustomDropdown';
export const PageWrap = styled.div`
  font-family: 'Nunito';
  color: ${({ theme }) => theme.primaryLight3};
  padding: 12px 32px 32px;
  font-weight: 400;
  h1,
  .h1,
  h2,
  .h2,
  h3,
  .h3,
  h4,
  .h4,
  h5,
  .h5,
  h6,
  .h6 {
    font-family: 'Nunito';
  }
  .form-check-input:checked {
    background-color: ${({ theme }) => theme.mainPrimary};
    border-color: ${({ theme }) => theme.mainPrimary};
  }
  .form-check-input:focus {
    box-shadow: none;
  }
`;

export const ForumHome = styled.div`
  font-family: 'Nunito';
  font-weight: 400;
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: 'Nunito';
    color: ${({ theme }) => theme.grayNew};
  }
`;

export const AvatarGroup = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
`;
export const Trucate = styled.h6`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  max-width: 100%;
`;

export const RowStyle = styled(Row)`
  position: relative;
  z-index: 2;
`;

export const SignInBox = styled.p`
  border-radius: 7px;
  font-size: 14px;
  font-weight: 500;
  line-height: 19px;
  padding: 12px;
  margin-top: 32px;
  border: 1.25px solid ${({ theme }) => theme.lightGray1};
  z-index: 999;
  svg {
    margin-right: 10px;
  }
  &.selling-alert {
    color: ${({ theme }) => theme.primaryDark};
  }
`;
export const ProfileName = styled.h6`
  font-size: 16px;
  font-weight: 600;
  margin: 0 8px 0 0 !important;
`;
export const AvatarStatus = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 100%;
  border: 1px solid ${({ theme }) => theme.white};
  position: absolute;
  background-color: #d9d9d9;
  bottom: 0px;
  right: 2px;
  &.online {
    background-color: #76cc57;
  }
`;
export const ProfileContent = styled.div`
  display: flex;
  align-items: center;
  span {
    color: ${({ theme }) => theme.primaryDark}99;
    font-size: 14px;
    font-weight: 500;
    margin-right: 8px;
  }
  svg {
    margin: 0 6px;
  }
  .time {
    font-size: 12px;
    color: ${({ theme }) => theme.gray40};
    font-weight: 400;
  }
`;
export const TopicFooter = styled.div`
  justify-content: space-between;
`;
export const ProfileImage = styled.div`
  position: relative;
  span {
    height: 10px;
    width: 10px;
    background-color: #76cc57;
    border: 1px solid ${({ theme }) => theme.white};
    border-radius: 50px;
    position: absolute;
    bottom: 0;
    right: 5px;
  }
  img {
    height: 37px;
    width: 37px;
    margin-right: 10px;
  }
`;

export const Avatar = styled.span`
  width: 30px;
  height: 30px;
  display: inline-flex;
  border: 1px solid ${({ theme }) => theme.white};
  box-sizing: content-box;
  position: relative;
  &:not(:last-child) {
    margin-left: -8px;
  }
  img {
    width: 100%;
    height: 100%;
    max-height: auto;
    border-radius: inherit;
    object-fit: cover;
  }
`;
export const FooterPagination = styled.div`
  padding: 0 32px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const RowSelect = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  white-space: nowrap;
  flex: 1;
  .custom-drop-down-width,
  .custom-drop-down {
    max-width: 115px;
    margin-right: 18px;
  }
`;

export const TabHeading = styled.h5`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.body};
  &.margin-top {
    margin-bottom: 0px !important;
  }

  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      font-size: 14px;
      margin-bottom: 10px;
      margin-top: 10px !important;
    }
  `}
`;

export const TopicsFilter = styled.div`
  max-width: 1500px;
  margin-left: auto;
  width: auto;
  padding-left: 20px;
  @media screen and (max-width: 1400px) {
    max-width: 940px;
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      padding-left: 0;
    }
  `}
`;
export const FooterButtons = styled.div``;
export const AdminPageMain = styled.div`
  padding: 12px 32px 32px;
`;
export const TableField = styled.div`
  margin-bottom: 16px;
  input {
    border: 1.5px solid ${({ theme }) => theme.lightGray1};
    border-radius: 8px;
    p,
    &::placeholder {
      font-size: 16px;
    }
  }
`;

export const HighLightText = styled.span`
  background-color: ${({ theme }) => theme.badgeText}1a;
  padding: 8px 16px;
  display: inline-flex;
  font-size: 18px;
  align-items: center;
  color: ${({ theme }) => theme.badgeText};
  border-radius: 50px;
  margin-bottom: 25px;
  svg {
    margin-right: 10px;
  }
`;

export const TopicHeading = styled.h6`
  font-weight: 400;
  font-size: 16px;
  margin-bottom: 8px;
  color: ${({ theme }) => theme.secondaryLight};
`;
export const Counter = styled.ul`
  padding: 36px 0 0 0;
  margin: 0;
  list-style: none;
  z-index: 1;
  position: relative;
  li {
    padding-right: 96px;
    position: relative;
    &:last-child {
      padding: 0;
      &::after {
        display: none;
      }
    }
    &::after {
      top: 50%;
      transform: translateY(-50%);
      content: '';
      height: 66px;
      width: 1px;
      right: 48px;
      background-color: ${({ theme }) => theme.mainPrimary};
      position: absolute;
    }
    h5 {
      font-size: 48px;
      color: ${({ theme }) => theme.secondaryLight};
      line-height: 1.36;
      font-family: 'Source Serif 4', serif;
      font-weight: 400;
      margin-bottom: 0px;
      text-transform: uppercase;
    }
    span {
      color: ${({ theme }) => theme.secondaryLight};
      font-size: 20px;
      opacity: 0.8;
    }
  }
`;
export const AddTopic = styled.div`
  background-color: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.lightGray1};
  border-radius: 4px;
  padding: 24px;
  .table-fild {
    margin-bottom: 16px;
    input {
      border: 1px solid ${({ theme }) => theme.lightGray1};
      border-radius: 8px;
      p,
      &::placeholder {
        font-size: 16px;
      }
    }
  }
  .topic-heading {
    font-weight: 400;
    font-size: 16px;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.secondaryLight};
  }
  .topic-inputs {
    svg {
      height: 16px;
      width: 16px;
    }
    h6 {
      font-size: 16px;
      font-weight: 400;
    }
    font-size: 16px;
    min-height: 48px;
  }
  textarea {
    &.topic-inputs {
      border: 1px solid ${({ theme }) => theme.primary};
      border-radius: 5px;
      padding: 10px 18px;
    }
  }
  .footer-buttons {
    margin-top: 32px;
  }
  .e-toolbar-items span:before {
    color: ${({ theme }) => theme.gray};
  }
`;

export const BannerButton = styled(CustomButton)`
  background-color: ${({ theme }) => theme.mainPrimary};
  font-size: 20px;
  padding: 15px 30px;
  border-radius: 50px;
  margin-bottom: 100px;
  border-color: ${({ theme }) => theme.mainPrimary};
  &:hover,
  &:focus,
  &:active {
    border-color: ${({ theme }) => theme.mainPrimary} !important;
    background-color: ${({ theme }) => theme.mainPrimary} !important;
  }
`;

export const CounterBanner = styled.div`
  margin-top: -40px;
  border-bottom: 36px solid ${({ theme }) => theme.mainPrimary}0d;
  position: relative;
  &::after {
    border-top-right-radius: 25px;
    top: 0;
    left: -10%;
    position: absolute;
    width: 51%;
    height: 100%;
    z-index: 0;
    content: '';
    background-color: ${({ theme }) => theme.mainPrimary};
    opacity: 0.05;
    transform: skew(35deg, 0deg);
  }
  &::before {
    border-radius: 0 0 0 15px;
    bottom: -0.3px;
    left: 42.4%;
    position: absolute;
    width: 30px;
    height: 50px;
    z-index: 1;
    content: '';
    background-color: ${({ theme }) => theme.white};
    transform: skew(30deg, 0deg);
    @media only screen and (max-width: 1600px) {
      left: 42.7%;
    }
  }
`;

export const ForumBanner = styled.div`
  padding: 100px 0 52px;
  position: relative;
  background-color: ${({ theme }) => theme.white};
  &::after {
    height: 226px;
    width: 157px;
    background-repeat: no-repeat;
    background-position: right;
    content: '';
    right: 0;
    bottom: 126px;
    position: absolute;
    background-image: url(${bgFlower});
  }
  &::before {
    height: 140px;
    width: 92px;
    background-repeat: no-repeat;
    background-position: right;
    content: '';
    top: 0;
    right: 10%;
    position: absolute;
    background-image: url(${bgBasket});
  }
`;
export const BannerInfo = styled.div`
  max-width: 550px;
  h1 {
    line-height: 1.36;
    font-size: 52px;
    font-family: 'Source Serif 4', serif;
    color: ${({ theme }) => theme.secondaryLight};
    position: relative;
    margin-bottom: 32px;
    &::after {
      position: absolute;
      height: 27px;
      max-width: 350px;
      width: 100%;
      bottom: 4px;
      left: 0;
      background: #7d3dae1a;
      content: '';
    }
  }
  p {
    color: ${({ theme }) => theme.secondaryLight};
    font-size: 18px;
    margin-bottom: 32px;
  }
`;
export const ForumFilter = styled.div`
  .filter-topic {
    h6 {
      font-size: 18px;
      color: ${({ theme }) => theme.secondaryLight};
      margin-bottom: 16px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      li {
        text-decoration: none;
        font-size: 18px;
        margin-bottom: 12px;
        color: ${({ theme }) => theme.secondaryLight};
        &.active {
          color: ${({ theme }) => theme.mainPrimary};
          font-weight: 600;
        }
      }
    }
  }
`;
export const FilterHeading = styled.h6`
  color: ${({ theme }) => theme.secondaryLight};
  font-size: 18px;
  padding-bottom: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.lightGray1};
  margin: 0;
`;

export const FilterRadio = styled.div`
  padding: 24px 0;
  border-bottom: 1px solid ${({ theme }) => theme.lightGray1};
  margin-bottom: 15px;
  p {
    margin-bottom: 19px;
    &:last-child {
      margin: 0;
    }
  }
  input {
    height: 20px;
    width: 20px;
    vertical-align: middle;
    margin-right: 12px;
    accent-color: ${({ theme }) => theme.mainPrimary};
  }
  label {
    color: $dark;
    vertical-align: middle;
    font-size: 18px;
  }
`;
export const FilterTopic = styled.div`
  h6 {
    font-size: 18px;
    color: ${({ theme }) => theme.secondaryLight};
    margin-bottom: 16px;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    li {
      text-decoration: none;
      font-size: 18px;
      margin-bottom: 12px;
      color: ${({ theme }) => theme.secondaryLight};
      &.active {
        color: ${({ theme }) => theme.mainPrimary};
        font-weight: 600;
      }
    }
  }
`;
export const TopicTopBar = styled.div`
  padding: 0 32px;
`;

export const HomeTopicSearch = styled(SearchInput)`
  margin-bottom: 16px;
  padding: 8px 42px 8px 22px;
  font-size: 16px;
  border-radius: 6px;
  font-weight: 600;
  color: ${({ theme }) => theme.secondaryLight};
  border: 1.25px solid ${({ theme }) => theme.lightGray1};
  &::placeholder {
    font-size: 16px;
    color: ${({ theme }) => theme.secondaryLight};
    font-weight: 600;
  }
`;

export const TopicButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 24px;
  .topic-button {
    margin-right: 10px;
    border-radius: 6px;
    padding: 10px 16px;
    background-color: ${({ theme }) => theme.mainPrimary};
    font-size: 16px;
    svg {
      margin-left: 12px;
    }
  }
`;
export const TopicSubButtons = styled(CustomButton)`
  margin-right: 10px;
  border-radius: 6px;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.mainPrimary};
  border-color: ${({ theme }) => theme.mainPrimary};
  font-size: 16px;
  svg {
    margin-left: 12px;
  }
  &:hover,
  &:focus,
  &:active {
    border-color: ${({ theme }) => theme.mainPrimary} !important;
    background-color: ${({ theme }) => theme.mainPrimary} !important;
  }
`;
export const Results = styled.h6`
  font-weight: 400;
  font-size: 20px;
  span {
    font-weight: 600;
  }
`;
export const HomeTopicList = styled.div`
  border-radius: 12px;
  padding: 32px 0;
  border: 1px solid ${({ theme }) => theme.lightGray1};
  .search-icon {
    height: 42px;
    width: 42px;
    border-radius: 0 6px 6px 0;
    display: flex;
    position: absolute;
    right: 0;
    top: 0;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.mainPrimary};
  }
`;

export const Topic = styled.li`
  cursor: pointer;
  padding: 32px;
  width: 100%;
  transition: all 0.3s ease-in-out;
  border-bottom: 1.25px solid ${({ theme }) => theme.lightGray1};
  &:hover {
    transition: all 0.3s ease-in-out;
    background: #f9f6fb;
  }

  h6 {
    margin-bottom: 12px;
    font-size: 16px;
    color: ${({ theme }) => theme.grayNew};
  }
  p {
    font-size: 14px;
    margin-bottom: 18px;
  }
  &:last-child {
    border: 0;
  }
`;
export const AdminTopic = styled.li`
  padding: 20px;
  width: 100%;
  transition: all 0.3s ease-in-out;
  //border: 1.5px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  margin-bottom: 12px;
  background-color: ${({ theme }) => theme.white};
  &:hover {
    background-color: ${({ theme }) => theme.white};
    cursor: pointer;
  }
  h6 {
    margin-bottom: 12px;
    font-size: 16px;
    font-weight: 500;
    color: ${({ theme }) => theme.primaryDark};
    .pin-icon,
    .bookmark-icon {
      color: ${({ theme }) => theme.primary};
    }
  }
  p {
    font-size: 14px;
    margin-bottom: 18px;
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      padding: 10px;
    }
  `}
  .topic-heading {
    font-size: 22px;
    font-weight: 700;
  }
`;

export const NewTopic = styled.div`
  margin-right: -11px;
  height: 29px;
  color: ${({ theme }) => theme.white};
  text-align: center;
  line-height: 29px;
  font-size: 16px;
  font-weight: 600;
  position: relative;
  width: 95px;
  svg {
    color: ${({ theme }) => theme.primary};
  }
  p {
    position: absolute;
    top: 0;
    right: 18px;
    z-index: 99;
    margin-top: 1px;
    padding-right: 6px;
    color: ${({ theme }) => theme.white};
    font-size: 16px;
    font-weight: 500;
  }
`;

export const ShowTwoLine = styled.p`
  line-height: 1.5em;
  min-height: 3em;
  height: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.primaryDark}cc;
  font-size: 14px;
  line-height: 18px;

  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      line-height: normal;
    }
  `}
`;
export const TopicListUL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const AdminCombineTopicListUL = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1.5px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  margin-bottom: 12px;
  h6 {
    margin-bottom: 12px;
    font-size: 16px;
    color: ${({ theme }) => theme.primaryDark};
  }
  p {
    font-size: 14px;
    margin-bottom: 18px;
  }
  &:last-child {
    border: 0;
  }
`;

export const ForumMain = styled.div`
  background-color: ${({ theme }) => theme.white};
  margin-bottom: -1.5rem;
  padding-bottom: 50px;
`;

export const BothContainerAndMain = styled.div`
  background-color: ${({ theme }) => theme.white};
  margin-bottom: -1.5rem;
  padding-bottom: 50px;
  position: relative;
  background-color: ${({ theme }) => theme.white};
  margin-bottom: -1.5rem;
  padding-bottom: 50px;
  z-index: 1;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 180px;
    width: 157px;
    background-image: url(${ShopIcon});
    background-position: left bottom;
    background-repeat: no-repeat;
    z-index: -1;
  }
`;

export const ForumContainer = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.white};
  margin-bottom: -1.5rem;
  padding-bottom: 50px;
  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 180px;
    width: 157px;
    background-image: url(${ShopIcon});
    background-position: left bottom;
    background-repeat: no-repeat;
  }
`;

export const headerDropdown = styled.div`
  width: 100%;
  height: 100%;
`;

export const FormOrders = styled.div`
  ${({ size }) => css`
    font-size: 18px;
    border: 1px solid ${({ theme }) => theme.lightGray1};
    padding: ${size === 'small' ? '2.5px' : '4px'};
    border-radius: 8px;
    display: flex;
    flex: 1;
    span {
      padding: ${size === 'small' ? '2px 20px' : '12px 24px'};
      border-radius: 6px;
      flex: 1;
      text-align: center;
      font-size: 14px;
      color: ${({ theme }) => theme.mainPrimary};
      cursor: pointer;
      @media screen and (max-width: 1700px) {
        padding: ${size === 'small' ? '2px 12px' : '12px 24px'};
      }
      &.active {
        background-color: ${({ theme }) => theme.mainPrimary};
        color: ${({ theme }) => theme.white};
      }
    }
  `}
`;

export const AdminTopicList = styled.ul`
  border: 1.5px solid ${({ theme }) => theme.lightGray1};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.white};
  margin-bottom: 12px;
  &:hover {
    background-color: ${({ theme }) => theme.white};
  }
`;
export const AdminTopicListMain = styled.div`
  .search-input {
    &::placeholder {
      font-size: 16px;
    }
  }
  .header-dropdown {
    width: 100%;
    height: 100%;
  }
`;

export const AdminTopicListMainAndMainPage = styled.div`
  padding: 12px 32px;
  .search-input {
    &::placeholder {
      font-size: 16px;
    }
  }
  .header-dropdown {
    width: 100%;
    height: 100%;
  }
  .topics-filter-header {
    margin: -6px;
    flex: 1;
    button {
      font-size: 14px;
    }
    [class*='col-'] {
      padding: 6px;
    }
  }
  .search-bar {
    width: 285px;
    @media (max-width: 991px) {
      width: 100%;
    }
    .form-control {
      padding: 6px 30px 6px 8px;
    }
    .search-icon {
      margin-left: -26px;
    }
  }
  .category {
    width: 165px;
    @media (max-width: 991px) {
      width: 100%;
    }
    .custom-drop-down {
      border-radius: 4px;
      .menu-toggle {
        height: 30px;
        h6 {
          color: #242424 !important;
        }
        svg {
          height: 20px;
          width: 20px;
        }
      }
    }
  }
  .reset-filter {
    width: 108px;
  }
  .start-scavenging {
    width: 142px;
    div {
      display: block;
      width: 100%;
    }
    .btn {
      font-weight: 400;
      margin-right: 0;
      width: 100%;
    }
  }
`;

export const PageResult = styled.span`
  font-size: 18px;
  white-space: nowrap;
  color: ${({ theme }) => theme.secondaryLight};
  margin-right: 20px;
  &.page-result {
    color: ${({ theme }) => theme.menuText};
    font-weight: 400;
    opacity: 0.6;
  }
`;

export const BreadcrumbPostion = styled.div`
  margin-top: -22px;
  margin-bottom: 12px;
`;

export const CardFooterPagination = styled.div`
  margin-bottom: 32px;
  display: flex;
  align-items: center;
  margin-left: -30px;
  margin-right: -30px;
  .pagination-container {
    margin: 0;
    padding: 0;
  }
`;
export const NextPreviewButton = styled.div`
  display: flex;
  margin-left: auto;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: 10px;
    justify-content: center;
    .prew {
      margin-left: 0;
    }
  }
`;
export const Catefory = styled.span`
  color: ${({ theme }) => theme.badgeText};
  background-color: ${({ theme }) => theme.badgeText}1a;
  padding: 8px 16px;
  border-radius: 10px;
  font-size: 12px;
  display: inline-block;
  position: relative;
  z-index: 2;
`;
export const PrevButton = styled(CustomButton)`
  font-size: 16px;
  color: ${({ theme }) => theme.mainPrimary};
  font-weight: 500;
  background-color: transparent;
  border: none;
  margin: 0 28px;
  svg {
    margin: 0 10px;
  }
  &:hover {
    background-color: transparent;
    color: ${({ theme }) => theme.mainPrimary} !important;
  }
  &:active {
    background-color: transparent !important;
    color: ${({ theme }) => theme.mainPrimary} !important;
  }

  &.disable {
    cursor: not-allowed;
  }

  &.prew {
    position: relative;
    &::after {
      position: absolute;
      content: '';
      height: 18px;
      width: 1px;
      right: -28px;
      top: 50%;
      background-color: ${({ theme }) => theme.primary};
      transform: translateY(-50%);
    }
  }
`;
export const CardHeader = styled.div`
  card-header {
  }
`;
export const ReplayCard = styled.div`
  background-color: ${({ theme }) => theme.white};
  margin-bottom: 24px;
  position: relative;
  &.card-separater {
    border: 0;
    background-color: transparent;
    padding: 0;
    .card-header {
      background-color: ${({ theme }) => theme.white};
      border-radius: 8px;
      margin-bottom: 10px;
      padding: 5px 0;
    }
    .card-separater-content {
      background-color: ${({ theme }) => theme.white};
      border-radius: 8px;
      margin-bottom: 10px;
      padding: 22px;
      .custom-drop-down {
        max-width: max-content;
        margin-left: auto;
      }
      .menu-toggle {
        height: 34px;
      }
      .notification-level-dropdown {
        min-width: 136px;
        .notification-level-dropdown-menu {
          min-width: 400px !important;
          overflow: hidden;
        }
      }

      ${({ theme }) => css`
        @media (max-width: ${theme?.breakpoints?.sm}px) {
          padding: 10px;
        }
      `}
      .topic-heading {
        font-size: 22px;
        font-weight: 700;
      }
      .topic-description {
        font-size: 16px;
        color: ${({ theme }) => theme.gray80};
      }
    }
    }
  }
  &.inner-reply {
    .card-header {
      .header-time {
        font-size: 13px;
        ${({ theme }) =>
          css`
            @media (max-width: ${theme?.breakpoints?.sm}px) {
              font-size: 10px;
            }
          `};
      }
    }
    &.sub-inner-reply {
      margin-top: -8px;
    }
    &.child {
      margin-left: ${({ value }) => value}px;
    }
    &.parent,
    &.child {
      ${({ theme, showSubTopics, height }) => {
        if (showSubTopics) {
          return `
        .profile {
          position: relative;
          &:after {
            content: '';
            position: absolute;
            top: 32px;
            left: 14px;
            width: 2px;
            height: ${height}px;
            background-color: ${theme.primaryLight2};
          }
        }
      `;
        } else {
          return '';
        }
      }}
    }
  .topicBookmark {
    min-width: 136px;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 6px 12px;
    border-radius: 8px;
    margin-bottom: 8px;
    border: 1px solid ${({ theme }) => theme.inputBorder};
    //background-color: ${({ theme }) => theme.lightGray1};
    font-size: 14px;
    color: ${({ theme }) => theme.primaryDark};

    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
  .drop-button {
    padding: 6px 12px !important;
  }
  .card-header {
    display: flex;
    margin-bottom: 26px;
    justify-content: space-between;
    &.card-header-border {
      border: 1px solid ${({ theme }) => theme.lightGray1};
    }
    .profile {
      display: flex;
      align-items: center;
      span {
        font-size: 14px;
        color: ${({ theme }) => theme.secondaryLight};
      }
      h6 {
        font-size: 16px;
        margin: 0;
        &.user-name {
          font-size: 12px;
          font-weight: 700;
        }
      }
      .description {
        font-size: 14px;
      }
      ._image {
        height: 32px;
        align-self: start;
        width: 32px;
        margin-right: 12px;

        ${({ theme }) => css`
          @media (max-width: ${theme?.breakpoints?.sm}px) {
            margin-right: 7px;
          }
        `}
      }
    }
    .header-time {
      font-size: 18px;
      color: ${({ theme }) => theme.secondaryLight};
      font-weight: normal;
    }
  }
  .card-content {
    h6 {
      font-size: 24px;
      margin-bottom: 16px;
    }
    p {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
  .card-footer {
    display: flex;
    position: relative;
    align-items: center;
    span {
      color: ${({ theme }) => theme.secondaryLight};
      cursor: pointer;
      margin-right: 25px;
      font-size: 14px;
      &:last-child {
        margin-right: 0;
      }
      svg {
        margin-right: 10px;
        color: ${({ theme }) => theme.primary};
      }
    }
    ${({ theme }) => css`
      @media (max-width: ${theme?.breakpoints?.sm}px) {
        svg {
          width: 16px;
          height: 16px;
        }

        span {
          margin-right: 10px;
        }
      }
    `}
    &.main-container {
      padding-bottom: 15px;
      margin-bottom: 5px;
      border-bottom: 1px solid ${({ theme }) => theme.borderColor};
    }
    .footer-date {
      font-size: 11px;
      font-weight: 400;
      color: ${({ theme }) => theme.gray70}
    }
  }
  .collapse-arrow {
    position: absolute;
    left: 8px;
    top: 8px;
  }
`;
export const ReplayTo = styled.div`
  .reply-to-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    h6 {
      font-size: 16px;
    }
  }
  &.reply-to-inside {
    margin-bottom: 24px;
    border-radius: 8px;
    padding: 26px 24px;
    background-color: ${({ theme }) => theme.white};
  }
  &.sub-reply {
    margin: 0;
    padding-bottom: 0;
    ${({ theme }) => css`
      @media (max-width: ${theme?.breakpoints?.sm}px) {
        position: fixed;
        left: 0;
        width: 100%;
        bottom: 0;
        background: ${({ theme }) => theme.white};
        z-index: 999;
        border-radius: 0;
        box-shadow: 0px -5px 9px rgba(0, 0, 0, 0.2);
      }
    `}
  }
  h6 {
    font-size: 18px;
    margin-bottom: 12px;
  }
  .catagory {
    color: ${({ theme }) => theme.badgeText};
    background-color: ${({ theme }) => theme.badgeText}1a;
    padding: 8px 16px;
    border-radius: 10px;
    font-size: 12px;
    display: inline-block;
  }
  .sign-in-box {
    margin-top: 22px;
  }
`;

export const TopFilters = styled('div')`
  display: flex;
  align-items: center;
  button {
    &:first-child {
      padding: 8px 14px;
      height: 38px;
      margin-right: 0px !important;
      font-size: 16px;
      font-weight: 600;
      flex: 1;
      justify-content: center;
      @media screen and (max-width: 1700px) {
        margin-right: 10px;
        flex: none;
      }
    }
  }
  .topicBtn {
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
`;
export const TopicAction = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  > svg {
    margin-right: 10px;
    color: ${({ theme }) => theme.primaryDark};

    &.like-icon {
      color: ${({ theme }) => theme.badgeText};
      width: 20px;
      height: 20px;
    }
  }
  .dropdown-toggle {
    svg {
      color: ${({ theme }) => theme.primaryLight};
    }
    &:after {
      content: normal;
    }
  }
  .custom-drop-down {
    .dropdown-toggle {
      padding: 5px;
      margin: -5px;
    }
    .menu-dropdown {
      transform: none !important;
      inset: 30px 0px auto auto !important;
      min-width: 12rem;
      svg {
        color: ${({ theme }) => theme.primary};
      }
    }
  }
  ${Avatar} {
    width: 20px;
    height: 20px;
  }
`;
export const EditsAction = styled('div')`
  display: flex;
  align-items: center;
  svg {
    color: ${({ theme }) => theme.primaryDark};
    margin-right: 10px;
  }
`;
export const StyledLine = styled.div`
  ${({ theme }) => {
    return `
          &.styled-line {
            position: absolute;
            top: 9px;
            left: -28px;
            height: 10px;
            border-bottom-left-radius: 6px 6px;
            width: 28px;
            background-color: transparent;
            border-left: 2px solid ${theme.primaryLight2};
            border-bottom: 2px solid ${theme.primaryLight2};
          }
        `;
  }}
`;
export const TopicFilter = styled(Row)`
  .headerSearch {
    width: 206px;
    border-radius: 4px !important;
    input {
      border: 1px solid ${({ theme }) => theme.gray40};
      height: 38px;
      padding: 10px 10px 10px 30px !important;
    }
    color: ${({ theme }) => theme.grayNew} !important;
    &::placeholder {
      color: ${({ theme }) => theme.gray40} !important;
    }
    .icon-small {
      position: absolute;
      left: 8px;
      svg {
        color: ${({ theme }) => theme.gray40} !important;
      }

      margin-left: 0 !important;
    }

    ${({ theme }) => css`
      @media (max-width: ${theme?.breakpoints?.sm}px) {
        width: 100%;
      }
    `}
  }
  .headerFilter {
    //width: 116px;
    margin-left: 13px;
    .custom-drop-down {
      border: 1px solid ${({ theme }) => theme.gray40};
      border-radius: 7px !important;
      svg {
        color: ${({ theme }) => theme.gray40}!important;
      }
    }
    .table-dropdown {
      padding: 10px !important;
    }
    svg {
      width: 16px;
      height: 16px;
    }
    .dropdown-filters .menu-dropdown {
      min-width: auto !important;
    }
  }
  .latestBtn {
    width: 86px;
    border-radius: 4px !important;
    margin-left: 13px;
    height: 32px;
  }
  .topicBtn {
    border-radius: 4px !important;
    margin-left: 13px;
    margin-right: 13px !important;
    svg {
      color: ${({ theme }) => theme.primary};
    }
  }
  .discussBtn {
    border-radius: 4px !important;
    width: 178px !important;
    span {
      padding: 2px 11px !important;
      height: 26px !important ;
      border-radius: 4px !important;
    }
  }
`;

export const SolutionCheck = styled.div`
  display: inline-block;
  margin-left: 3px;
  color: ${({ checked, theme }) => (checked ? theme.primary : theme.body)};
  font-size: 14px;
  svg {
    vertical-align: -8px;
  }
`;

export const AcceptedAnswer = styled.div`
  background-color: ${({ theme }) => theme.primaryLight2};
  border-left: 4px solid ${({ theme }) => theme.primary};
  padding: 10px;
  margin-bottom: 20px;
  color: ${({ theme }) => theme.body};
  font-size: 14px;
  svg {
    color: ${({ theme }) => theme.primary};
    vertical-align: -5px;
  }
  p {
    margin-top: 8px;
    margin-bottom: 0 !important;
  }
  span {
    font-weight: 500;
  }
`;

export const NotificationLevelList = styled.div`
  max-width: 400px !important;
  overflow: hidden !important;
  .icon-primary {
    color: ${({ theme }) => theme.primary};
  }
`;
export const NotificationLevel = styled.div`
  padding: 8px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  h5 {
    font-weight: 500;
  }
  background-color: ${({ theme, active }) =>
    active ? theme.lightGray1 : theme.transparent};
  &:hover {
    background-color: ${({ theme }) => theme.lightGray1};
  }
`;

export const ReactionTooltip = styled.div`
  background-color: ${({ theme }) => theme.primaryDark};
  padding: 10px 8px;
  display: none;
  margin: 6px 0;
  position: absolute;
  top: -50px;
  cursor: pointer;
  border-radius: 4px;
  left: 0;
  z-index: 3;

  img {
    padding: 0 8px;
    transition: all 0.1s ease-in-out;
    &:hover {
      transition: all 0.1s ease-in-out;
      transform: scale(1.3);
    }
  }

  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      padding: 8px 6px;
      img {
        padding: 0 4px;
        height: 16px;
      }
    }
  `}
`;
export const ReactionTooltipWrapper = styled.div`
  &:hover {
    ${ReactionTooltip} {
      opacity: 1;
      display: inline-block;
    }
  }
`;

export const ButtonTabs = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      justify-content: start;
      margin-bottom: 10px;
    }
  `}
`;

const TabsSingleButton = styled(StyledButton)`
  background-color: ${({ theme, selected }) =>
    selected ? theme.primary : theme.white};
  border-radius: 15px;
  height: 30px;
  font-weight: 500;
  color: ${({ theme, selected }) => (!selected ? theme.primary : theme.white)};
  margin: 2px;
  @media (max-width: 575px) {
    font-size: 11px;
  }
`;

const RenderedReaction = styled.div`
  display: flex;
  align-items: center;
  margin-right: 5px;
  img {
    &:not(:first-of-type) {
      margin-left: -13px;
    }
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      img {
        height: 16px;
        color: ${({ theme }) => theme.gray40};
        &:not(:first-of-type) {
          margin-left: -10px;
        }
      }
    }
  `}
`;
const FilterButton = styled.div`
  border: 1px solid ${({ theme }) => theme.gray40};
  border-radius: 5px;
  cursor: pointer;
  color: ${({ theme }) => theme.gray40};
`;

const StyledModal = styled(Modal)`
  font-family: 'Nunito';
  .modal-header {
    border-color: ${({ theme }) => theme.borderColor}!important;
  }
  .modal-footer {
    border: 0;
  }
`;
const ActionButton = styled.div`
  background-color: ${({ theme }) => `${theme.primary}19`};
  border-radius: 15px;
  height: auto;
  padding: 5px 12px;
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.primary};
  margin: 2px;
  @media (max-width: 575px) {
    font-size: 11px;
  }
`;

const CustomFormusDropdown = styled(CustomDropdownStyle)`
  background-color: ${({ theme }) => theme.primaryLight2}!important;
  color: ${({ theme }) => theme.gray70}!important;
  border: none !important;

  .table-dropdown.menu-toggle {
    height: 35px;
  }
  .table-dropdown.menu-toggle svg,
  h6 {
    color: ${({ theme }) => theme.gray70}!important;
  }
  .menu-dropdown {
    min-width: 13rem !important;
  }
`;

const IconBadge = styled.div`
  border-radius: 8px;
  padding: ${({ padding }) => (padding ? padding : 8)}px;
  background-color: ${({ theme, hasNoBg }) =>
    hasNoBg ? theme.transparent : theme.primaryLight2};
  color: ${({ theme, hasNoBg, isLiked }) =>
    isLiked ? theme.primary : hasNoBg ? theme.gray70 : theme.gray40}!important;

  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      padding: 3px !important;
      display: flex;
      align-items: center;
    }
  `}
  ${({ svgSize }) => {
    if (svgSize) {
      return `
        svg {
          width: ${svgSize};
          height: ${svgSize};
        }
      `;
    }
  }}
  ${({ fontSize }) => {
    if (fontSize) {
      return `
         font-size: ${fontSize};
         span {
         font-size: ${fontSize}!important
         }
      `;
    }
  }}
  ${({ fontWeight }) => {
    if (fontWeight) {
      return `
         font-weight: ${fontWeight};
      `;
    }
  }}
`;

export const AdminNotificationLevelList = styled(NotificationLevelList)`
  padding: 25px;
  background-color: ${({ theme }) => theme.transparent};
  color: ${({ theme, active }) => (active ? theme.primary : theme.grayNew)};
  &:hover {
    color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.transparent};
  }
  .heading {
    color: ${({ theme }) => theme.grayNew};
    border-bottom: 1px solid ${({ theme }) => theme.gray40};
    padding-bottom: 15px;
  }
`;

const NotificationLevelItem = styled(NotificationLevel)`
  background-color: ${() => 'transparent'}!important;
  color: ${({ theme, active }) =>
    active ? theme.primary : theme.grayNew}!important;
  span,
  h5 {
    color: ${({ theme, active }) =>
      active ? theme.primary : theme.grayNew}!important;
  }
  svg {
    color: ${({ theme, active }) =>
      active ? theme.primary : theme.gray40}!important;
  }
  &:hover {
    span,
    h5 {
      color: ${({ theme }) => theme.primary}!important;
    }
    color: ${({ theme }) => theme.primary}!important;
    background-color: ${() => 'transparent'}!important;
  }
`;

const IconBadgeButton = styled.div`
  border-radius: 8px;
  padding: 7px 12px;
  background-color: ${({ theme, hasNoBg }) =>
    hasNoBg ? theme.transparent : theme.primaryLight2};
  color: ${({ theme, hasNoBg }) =>
    hasNoBg ? theme.gray70 : theme.gray40}!important;
  h6,
  span {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: ${({ theme, hasNoBg }) =>
      hasNoBg ? theme.gray70 : theme.gray40}!important;
  }
  span {
    margin-left: 4px;
  }
  svg {
    width: 20px;
    height: 20px;
  }
  ${({ theme }) => css`
    @media (max-width: ${theme?.breakpoints?.sm}px) {
      padding: 3px 5px;
      svg {
        width: 18px;
        height: 18px;
      }
      h6 {
        font-size: 12px;
      }
    }
  `}
  ${({ svgSize }) => {
    if (svgSize) {
      return `
        svg {
          width: ${svgSize};
          height: ${svgSize};
        }
      `;
    }
  }}
  ${({ fontSize }) => {
    if (fontSize) {
      return `
         font-size: ${fontSize};
      `;
    }
  }}
  ${({ fontWeight }) => {
    if (fontWeight) {
      return `
         font-weight: ${fontWeight};
      `;
    }
  }}
`;

export const ForumStyled = {
  TabsSingleButton,
  ActionButton,
  NotificationLevelItem,
  IconBadge,
  IconBadgeButton,
  CustomFormusDropdown,
  AdminNotificationLevelList,
  FilterButton,
  StyledModal,
  RowStyle,
  ReplayTo,
  ReplayCard,
  Catefory,
  CardFooterPagination,
  PrevButton,
  NextPreviewButton,
  BreadcrumbPostion,
  PageResult,
  AdminCombineTopicListUL,
  AdminTopic,
  AdminTopicListMainAndMainPage,
  AdminTopicListMain,
  AdminTopicList,
  FormOrders,
  BothContainerAndMain,
  ForumContainer,
  ForumMain,
  SignInBox,
  ShowTwoLine,
  NewTopic,
  Topic,
  ButtonTabs,
  TopicListUL,
  TopicTopBar,
  HomeTopicSearch,
  TopicButtons,
  TopicSubButtons,
  Results,
  HomeTopicList,
  FilterTopic,
  FilterRadio,
  FilterHeading,
  PageWrap,
  TabHeading,
  TopicHeading,
  FooterButtons,
  TableField,
  AddTopic,
  AdminPageMain,
  ForumBanner,
  Counter,
  CounterBanner,
  BannerButton,
  HighLightText,
  BannerInfo,
  FooterPagination,
  RowSelect,
  AvatarGroup,
  Avatar,
  ProfileName,
  ProfileImage,
  AvatarStatus,
  ProfileContent,
  TopicFooter,
  ForumFilter,
  ForumHome,
  Trucate,
  TopFilters,
  TopicsFilter,
  TopicAction,
  EditsAction,
  TopicFilter,
  SolutionCheck,
  AcceptedAnswer,
  NotificationLevelList,
  NotificationLevel,
  ReactionTooltip,
  RenderedReaction,
  ReactionTooltipWrapper,
  StyledLine,
};
